import { render, staticRenderFns } from "./Outro.vue?vue&type=template&id=169b2131&scoped=true&"
import script from "./Outro.vue?vue&type=script&lang=js&"
export * from "./Outro.vue?vue&type=script&lang=js&"
import style0 from "./Outro.vue?vue&type=style&index=0&id=169b2131&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169b2131",
  null
  
)

export default component.exports